import React from "react";
import { findAllFormPagedEvent } from "../../_events/form/find.event";
import { alertError } from "../../_utils/alerts";

export const useFormPaged = (page = 0, limit = 8 ) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllFormPagedEvent(p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}